import {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import { dianaApi } from "../../services";
import { usePosts } from "../Posts";

const CategoriesContext = createContext();

export const CategoriesProvider = ({ children }) => {
  const [categories, setCategories] = useState([]);
  const [categoriesLoad, setCategoriesLoad] = useState(false);
  const [degCalc, setDegCalc] = useState(0);
  const [categoryColors, setCategoryColors] = useState({});
  const [activeCategory, setActiveCategory] = useState(0);
  const [category, setCategory] = useState({});
  const [showCategory, setShowCategory] = useState(false);
  const [colors, setColors] = useState([
    "--lightBlue",
    "--darkPink",
    "--darkBlue",
    "--lightPink",
    "--blue",
    "--lightPurple",
    "--darkPurple",
    "--lightGreen",
    "--green",
  ]);

  const { setShowPost } = usePosts();

  const categorySetter = (categoryId) => {
    setActiveCategory(categoryId);
    const cat = categories.filter((elem) => elem.id === categoryId);
    setCategory(cat[0]);
    setShowCategory(true);
    setShowPost(false);
  };

  const checker = (arr) => {
    return arr.some((elem) => elem === activeCategory);
  };

  const loadCategories = () => {
    setCategoriesLoad(true);

    dianaApi
      .get(`/categories?_embed&per_page=100`)
      .then((response) =>
        setCategories(response.data.sort((a, b) => (a.id < b.id ? 1 : -1)))
      )
      .then(() => setCategoriesLoad(false))
      .catch((error) => console.log(error));
  };

  const setCatColors = useCallback(() => {
    categories.forEach((item, index) => {
      let colorNumber = JSON.parse(JSON.stringify(index));

      if (index > 8) {
        colorNumber -= 8;
      }

      setCategoryColors((c) => ({
        ...c,
        [item.id]: colors[colorNumber],
      }));
    });
  }, [categories, colors]);

  useEffect(() => {
    setCategoriesLoad(true);
    loadCategories();
  }, []);

  useEffect(() => {
    if (categories.length > 0) {
      setDegCalc(360 / categories.length);
      setCatColors();
    }
  }, [categories, setCatColors]);
  return (
    <CategoriesContext.Provider
      value={{
        categories,
        categoriesLoad,
        degCalc,
        categoryColors,
        activeCategory,
        categorySetter,
        checker,
        category,
        showCategory,
        setColors,
        colors,
        setShowCategory,
      }}
    >
      {children}
    </CategoriesContext.Provider>
  );
};

export const useCategories = () => useContext(CategoriesContext);
